import { makeStyles } from '@material-ui/core'

const stylePaymentMessage = color => ({
  '& .MuiPaper-rounded': {
    borderColor: color
  },
  '& .title': {
    '& h2': {
      color
    }
  },
  '& .icon': {
    color
  },
  '& .content': {
    backgroundColor: `${color}30`
  },
  '& .message': {
    color
  },
  '& .actions .btn-cancel span': {
    color: '#d73f32'
  }
})

const useStyles = makeStyles({
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    paddingBottom: 30,
    '& label': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b',
      paddingBottom: 0
    },
    '& input, & .form-group > div': {
      minHeight: 44,
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      background: 'transparent',
      border: '2px solid #30287b'
    },
    '& small': {
      color: '#30287b',
      fontSize: '14px',
      fontStyle: 'italic',
      paddingTop: 6,
      textAlign: 'left'
    }
  },
  previewMemberDatas: {
    '& label': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b',
      paddingBottom: 0
    },
    '& .preview-stage': {
      width: 340,
      height: 225,
      backgroundColor: '#ece5fe',
      border: '2px solid #30287b',
      marginBottom: '30px',
      padding: '15px',
      '&.not-found': {
        backgroundColor: '#ffa49d',
        borderColor: '#d73f32',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .preview-stage__username': {
          color: '#d73f32'
        }
      }
    },
    '& .preview-stage__username': {
      fontSize: '25px',
      fontWeight: 700,
      color: '#30287b'
    }
  },
  hide: {
    display: 'none'
  },
  btnGenerate: {
    backgroundColor: 'var(--yellow-highlight)',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '36px',
    letterSpacing: 0,
    textAlign: 'center',
    color: 'var(--primary-color)',
    borderRadius: '2px',
    padding: 'inherit 15px',
    margin: '4px',
    boxShadow: '4px 4px 0px var(--primary-color)',
    transition: 'all 0.2s',
    bottom: 0,
    '&:hover, &:active': {
      boxShadow: '1px 1px 0px var(--primary-color)',
      backgroundColor: 'var(--yellow-highlight)',
      bottom: '-3px'
    },
    '&:focus': {
      boxShadow: '2px 2px 0px var(--primary-color)',
      outline: 'none',
      bottom: '-2px'
    }
  },
  btnCancel: {
    backgroundColor: 'var(--secondary-color)',
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '36px',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#d73f32',
    borderRadius: '2px',
    padding: 'inherit 15px',
    margin: '4px',
    transition: 'all 0.2s'
  },
  modalPaymentFeedback: {
    '& .MuiPaper-rounded': {
      borderRadius: 0,
      borderWidth: 2,
      border: 'solid',
      borderColor: '#000'
    },
    '& .title': {
      textTransform: 'uppercase',
      fontWeight: '700',
      padding: '45px 0',
      '& h2': {
        fontFamily: 'Matrice',
        fontSize: 24,
        display: 'flex',
        justifyContent: 'center',
        fontWeight: 'bold'
      }
    },
    '& .icon': {
      height: 135,
      width: 135,
      color: '#000'
    },
    '& .content': {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 50,
      backgroundColor: '#CCC'
    },
    '& .message': {
      fontFamily: 'Matrice',
      fontSize: 16,
      fontWeight: 'bold',
      color: '#000',
      marginTop: 32,
      maxWidth: 307,
      display: 'flex',
      textAlign: 'center'
    },
    '& .actions': {
      display: 'flex',
      justifyContent: 'center',
      padding: 20,
      '& button span': {
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        fontSize: 12,
        color: '#30287b'
      }
    },
    '&.success': stylePaymentMessage('#13735e'),
    '&.error': stylePaymentMessage('#d73f32'),
    '&.inprogress': stylePaymentMessage('#30287b')
  }
})

export default useStyles
